module.exports = __webpack_public_path__ + "static/media/generator.e2e598fb.png";